import { Controller } from "stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  
  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "AiProjectChannel" },
      {
        received: (data) => {
          this.addLog(data.message, data.block_id, data.icon)
        }
      }
    )
  }

  disconnect() {
    consumer.subscriptions.remove(this.subscription)
  }

  addLog(message, block_id, icon) {
    let container = document.querySelector(`[data-block-id="${block_id}"]`)
    let button = container.querySelector("button")

    // clear old text and insert new message
    button.innerHTML = icon ? `${message}&nbsp;${icon}` : message
  }
}
